// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"88":"d709f9e0","343":"e07acbef","875":"b37fad64"}[chunkId] + ".chunk.js";
};